import moment from 'moment';
import { Map, fromJS } from 'immutable';

import { START_EXPLICIT_WAITING, STOP_EXPLICIT_WAITING } from './actions';

const notWaiting = Map({
    startTime: null,
    message: null,
    transparent: null,
    visible: false,
});

export function explicitWaitReducer(state = notWaiting, action) {
    switch (action.type) {
        case START_EXPLICIT_WAITING:
            return fromJS({
                startTime: moment(),
                message: action.message,
                transparent: action.transparent,
                visible: true,
            });
        case STOP_EXPLICIT_WAITING:
            // Keeping message avoids the text changing while it fades away.
            return fromJS({
                startTime: null,
                message: state.get('message'),
                transparent: null,
                visible: false,
            });
    }
    return state;
}
